import React from 'react';
import { Tooltip } from '@mui/material';

const TYPE_META = {
    bounce: { label: 'Hard bounce', color: '#c62828' },
    espblock: { label: 'Blocked', color: '#e65100' },
    blacklisted: { label: 'Blacklisted', color: '#b71c1c' },
    'suppress-complaint': { label: 'Spam complaint', color: '#6a1b9a' },
    overquota: { label: 'Mailbox full', color: '#f57c00' },
    generic: { label: 'Delivery failed', color: '#616161' },
    old: { label: 'DNS failure', color: '#616161' },
    'suppress-bounce': { label: 'Suppressed', color: '#9e9e9e' },
    'smtp-hard': { label: 'Hard bounce (SMTP)', color: '#c62828' },
    'smtp-soft': { label: 'Soft bounce (SMTP)', color: '#f57c00' },
};

function kindColor(bounceKind) {
    if (bounceKind === 'hard') return '#c62828';
    if (bounceKind === 'soft') return '#f57c00';
    return '#616161';
}

/**
 * Single-column bounce display: Soft/Hard chip + "[code] message".
 */
function BounceReasonCell({ reason, code, bounceKind }) {
    if (!reason && !code && !bounceKind) {
        return <span style={{ color: '#bbb' }}>—</span>;
    }

    const message =
        (reason && (reason.message || reason.type)) ||
        (TYPE_META[reason && reason.type] &&
            TYPE_META[reason.type].label) ||
        '';
    const displayCode = code || (reason && reason.code) || null;
    const kind = bounceKind || (reason && reason.bounceKind) || null;
    const color = kindColor(kind);
    const line = displayCode
        ? `[${displayCode}] ${message}`.trim()
        : message || '—';

    return (
        <div style={{ lineHeight: '1.4', maxWidth: 320 }}>
            {kind === 'hard' || kind === 'soft' ? (
                <span
                    style={{
                        display: 'inline-block',
                        fontSize: 11,
                        fontWeight: 600,
                        letterSpacing: '0.03em',
                        textTransform: 'uppercase',
                        color,
                        background: color + '18',
                        borderRadius: 3,
                        padding: '1px 5px',
                        marginBottom: 3,
                        marginRight: 4,
                    }}
                >
                    {kind === 'hard' ? 'Hard' : 'Soft'}
                </span>
            ) : null}
            <Tooltip title={line} placement="top">
                <div
                    style={{
                        fontSize: 13,
                        color: '#444',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 300,
                        cursor: 'default',
                    }}
                >
                    {line}
                </div>
            </Tooltip>
            {reason && reason.suppress_count > 0 && (
                <div style={{ fontSize: 11, color: '#9e9e9e', marginTop: 1 }}>
                    +{reason.suppress_count} suppressed
                </div>
            )}
        </div>
    );
}

export default BounceReasonCell;

export function BounceKindCell({ value }) {
    if (value !== 'hard' && value !== 'soft') {
        return <span style={{ color: '#bbb' }}>—</span>;
    }
    const hard = value === 'hard';
    const color = hard ? '#c62828' : '#f57c00';
    return (
        <span
            style={{
                display: 'inline-block',
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: '0.03em',
                textTransform: 'uppercase',
                color,
                background: color + '18',
                borderRadius: 3,
                padding: '1px 5px',
            }}
        >
            {hard ? 'Hard' : 'Soft'}
        </span>
    );
}

export function humanizeEmailType(value) {
    if (!value) return '';
    return String(value)
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function bounceReasonSort(rowA, rowB) {
    const msg = (row) => {
        const original = row.original || {};
        const reason = original.reason;
        const code = original.code || (reason && reason.code) || '';
        const message =
            (reason && (reason.message || reason.type)) || '';
        return `${code} ${message}`.trim();
    };
    return msg(rowA).localeCompare(msg(rowB), undefined, {
        sensitivity: 'base',
    });
}
